
import Vue from 'vue'
import PointMap from '../../common/point-map/index.vue'
import PointTable from '../../common/point-table/index.vue'
import CashPointRow from '../cash-point-row/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

type Tab = 'table' | 'map'
type FiltersPopup = 'type' | 'region' | ''
type TypeFilter = 'cash_point' | 'atm'
type RegionFilter = number

interface Data {
  activeTab: Tab,
  filtersPopup: FiltersPopup,
  typeFilter: TypeFilter,
  regionFilter: RegionFilter,
  typeFilterLabels: Record<TypeFilter, string>,
  regions: any[]
}

export default Vue.extend({
  name: 'CashBlock',
  components: {
    PointMap,
    PointTable,
    CashPointRow
  },
  mixins: [staticBlockMixin],
  data (): Data {
    return {
      activeTab: 'table',
      filtersPopup: '',
      typeFilter: 'cash_point',
      typeFilterLabels: {
        atm: 'Банкоматы',
        cash_point: 'ПВН'
      },
      regionFilter: 0,
      regions: []
    }
  },

  async fetch () {
    try {
      this.regions = (await this.$shops.fetch('atm', 'cash_point')) || []
      this.regionFilter = this.regions[0].id
    } catch (error) {
      console.error(error)
    }
  },

  computed: {
    currentRegion () {
      return this.regions?.find((region: { id: number }) => region.id === this.regionFilter) || 'Иваново'
    },
    currentFiltersShops () {
      return this.currentRegion?.shops?.filter((point: { tags: string }) => point.tags?.includes(this.typeFilter))
    }
  },

  methods: {
    showFilters (key: Omit<FiltersPopup, ''>) {
      this.filtersPopup = this.filtersPopup !== key ? key : ''
    },
    changeTab (tab: Tab) {
      this.activeTab = tab
    },
    selectFilterAndHide (key: Omit<FiltersPopup, ''>, value: TypeFilter | number) {
      this.selectFilter(key, value)
      this.hideFilters()
    },
    selectFilter (key: Omit<FiltersPopup, ''>, value: TypeFilter | number) {
      switch (key) {
        case 'type':
          this.typeFilter = value
          break
        case 'region':
          this.regionFilter = value
          break
        default:
          break
      }
    },
    hideFilters () {
      this.filtersPopup = ''
    }
  }
})
